import styled from '@emotion/styled';
import { IMenuItemEntry } from '../../../../contentful/types/IMenuItem';
import { MainNavigationItems } from './MainNavigationItems';

interface IMainNavigationProps {
	type: 'primary' | 'secondary';
	items: IMenuItemEntry[];
	siteSectionId?: string;
	showBackground: boolean;
}

export function MainNavigation({
	type,
	items,
	showBackground,
	siteSectionId,
}: IMainNavigationProps) {
	return (
		<MainNavigationColumn>
			<MainNavigationItems
				items={items}
				showBackground={showBackground}
				siteSectionId={siteSectionId}
				type={type}
			/>
		</MainNavigationColumn>
	);
}

const MainNavigationColumn = styled.div`
	display: flex;
	align-items: center;
`;
